export default __webpack_public_path__ + "static/media/art-blk-poster-2.ee551758.jpg";